export default __webpack_public_path__ + "static/media/logo.0de8462e.svg";